import type { SolarProposalEquipmentSectionDto } from "~/api/dto/solar-proposal-equipment.dto"

import { SectionNotice } from "./SectionNotice"
import { Components } from "./sections/system"
import type {
  SolarPresentationAiCompute,
  SolarSectionState,
} from "./solar-presentation-data"
import {
  toAiComputeComponent,
  toSolarComponents,
} from "./solar-proposal-equipment"

/**
 * The component carousel. The equipment read loads and fails on its own, so
 * the sections above it stay rendered whatever happens here. A design with no
 * equipment shows no section at all.
 */
export const SolarEquipmentSection = ({
  proposalId,
  state,
  aiCompute = null,
}: {
  proposalId: string
  state: SolarSectionState<SolarProposalEquipmentSectionDto>
  /** The selected AI compute node, which gets the last slide. */
  aiCompute?: SolarPresentationAiCompute | null
}): JSX.Element | null => {
  if (state.status !== `ready`) {
    return (
      <SectionNotice
        id="components"
        state={state}
        noun="the system components"
      />
    )
  }

  const { equipment } = state.data
  const components = [
    ...(equipment ? toSolarComponents(equipment) : []),
    ...(aiCompute ? [toAiComputeComponent(aiCompute)] : []),
  ]

  return components.length > 0 ? (
    <Components key={proposalId} components={components} />
  ) : null
}
